import jwtDecode from "jwt-decode";
import { destroyCookie, parseCookies, setCookie } from "nookies";

import { helpers } from "../helpers/index";

class AuthService {
  // nookies/cookie take maxAge in SECONDS.
  private static readonly ACCESS_MAX_AGE = 7 * 24 * 60 * 60; // 7 days
  private static readonly REFRESH_MAX_AGE = 30 * 24 * 60 * 60; // 30 days

  /** Stores the access token only; navigation is the caller's job. */
  login(token: string) {
    setCookie(null, "accessToken", token, {
      maxAge: AuthService.ACCESS_MAX_AGE,
      path: "/",
    });
  }
  registerAccessToken(token: string | string[]) {
    if (typeof token === "string") this.login(token);
  }

  registerRefreshToken(token: string | string[]) {
    if (typeof token === "string") {
      setCookie(null, "refresh_token", token, {
        maxAge: AuthService.REFRESH_MAX_AGE,
        path: "/",
      });
    }
  }

  logout() {
    destroyCookie(null, "accessToken", { path: "/" });
    destroyCookie(null, "refresh_token", { path: "/" });
    sessionStorage.clear();
    return helpers.redirectTo("/");
  }
  isAuth() {
    const { accessToken } = parseCookies(null);
    if (accessToken) return;
    return helpers.redirectTo("/login");
  }
  checkTokenValidity() {
    const { accessToken } = parseCookies(null);

    try {
      if (accessToken && jwtDecode(accessToken)) {
        return true;
      }

      destroyCookie(null, "accessToken", { path: "/" });
      return false;
    } catch (e) {
      destroyCookie(null, "accessToken", { path: "/" });
      return false;
    }
  }
}
export default new AuthService();
